/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Date_Of_BirthInputs */

const en_clients_field_date_of_birth = /** @type {(inputs: Clients_Field_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of birth`)
};

const pt_br2_clients_field_date_of_birth = /** @type {(inputs: Clients_Field_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de nascimento`)
};

/**
* | output |
* | --- |
* | "Date of birth" |
*
* @param {Clients_Field_Date_Of_BirthInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_date_of_birth = /** @type {((inputs?: Clients_Field_Date_Of_BirthInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Date_Of_BirthInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_date_of_birth(inputs)
	return pt_br2_clients_field_date_of_birth(inputs)
});